import {Routes} from '@angular/router';
import {AuthGuard} from '../core/security/auth-guard.service';
import {RolesEnum} from '../core/security/roles.enum';
import {ModulesEnum} from '../core/security/modules.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {FaxListComponent} from './list/list.component';
import {SendFaxComponent} from './send-fax/send-fax.component';
import {FaxReportsSummaryComponent} from './fax-reports/summary/summary.component';

export const routes: Routes = [
  {
    path: 'list',
    component: FaxListComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.FaxGroup,
      package: ModulesEnum.FaxModule,
      permissions: [RolesEnum.Fax_View, RolesEnum.Fax_Edit, RolesEnum.Fax_Delete],
      animation: 'main',
      meta: {
        title: 'Fax Activity',
        override: true,
        description: 'Fax Activity Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'print',
      }
    }
  },
  {
    path: 'send-fax',
    component: SendFaxComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.FaxGroup,
      package: ModulesEnum.FaxModule,
      permissions: [RolesEnum.Fax_Edit, RolesEnum.Fax_Delete],
      animation: 'main',
      meta: {
        title: 'Send Fax',
        override: true,
        description: 'Send Fax Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'send',
      }
    }
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        children: [
          {
            path: 'summary',
            component: FaxReportsSummaryComponent,
            canActivate: [AuthGuard],
            data: {
              menuGroup: MenuGroupEnum.FaxGroup,
              package: ModulesEnum.FaxReportModule,
              permissions: [RolesEnum.FaxReportView, RolesEnum.FaxReportEdit, RolesEnum.FaxReportDelete],
              meta: {
                title: 'Fax Reports',
                override: true,
                description: 'Fax Reports',
                inSideMenu: true,
                iconClass: 'material-icons',
                iconClassCode: 'insert_chart_outlined',
                showDisabled: false
              }
            }
          },
        ]
      }
    ]
  },
];
